import React, { useContext, useEffect, useRef, useState } from 'react';
import { ThemeContext } from 'styled-components';

import { Close } from "../Icons";

import { TimerDismissButton as Button, TimerProgress } from "./styles";

const DEFAULT_TIMEOUT_IN_MS = 4000;







export const TimerDismissButton = ({
  className,
  onDismiss,
  timeout = DEFAULT_TIMEOUT_IN_MS }) =>
{
  const timeoutRef = useRef(null);
  const [progress, setProgress] = useState(0);
  const theme = useContext(ThemeContext);

  useEffect(() => {
    setProgress(100);

    timeoutRef.current = window.setTimeout(() => {
      onDismiss();
    }, timeout);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [onDismiss, timeout]);

  return /*#__PURE__*/(
    React.createElement(Button, {
      small: true,
      className: className,
      onClick: onDismiss,
      icon: /*#__PURE__*/React.createElement(Close, { color: theme.colors['Level 5'] }) }, /*#__PURE__*/

    React.createElement(TimerProgress, {
      progress: progress,
      diameter: 32,
      stroke: 2,
      color: theme.colors['Level 4'],
      animationDuration: timeout })));



};